// extracted by mini-css-extract-plugin
module.exports =  {"textarea":"bWyqKT0f","bordered":"GMfzX0Gl"};